'use strict';

var react = require('react');
var isNumber = require('lodash/isNumber');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

var isNumber__default = /*#__PURE__*/_interopDefault(isNumber);

/**
 * @example
 *  const [ref, hovered] = useHover<HTMLDivElement>();
 *  return <Background
 *      ref={ref}
 *      color={hovered ? 'gray-100' : 'white'} />
 *
 * @see https://gist.github.com/gragland/a32d08580b7e0604ff02cb069826ca2f
 */
function useHover(props) {
    const [element, setElement] = react.useState(null);
    const timeout = react.useRef();
    const delay = props?.delay;
    const hoverDelay = delay && (isNumber__default.default(delay) ? delay : delay.hover);
    const unhoverDelay = delay && (isNumber__default.default(delay) ? delay : delay.unhover);
    const [hovered, setIsHovered] = react.useState(false);
    react.useEffect(() => {
        if (element == null) {
            return;
        }
        const setDelayedHover = (isHovered, delay) => {
            if (timeout.current) {
                clearTimeout(timeout.current);
            }
            if (delay) {
                timeout.current = setTimeout(() => setIsHovered(isHovered), delay);
            }
            else {
                setIsHovered(isHovered);
            }
        };
        const handlePointerEnter = () => setDelayedHover(true, hoverDelay);
        const handlePointerLeave = (event) => {
            if (element.contains(event.target)) {
                setDelayedHover(false, unhoverDelay);
            }
        };
        if (timeout.current) {
            clearTimeout(timeout.current);
        }
        // We are using pointer events here instead of mouseenter and mouseleave to allow triggering these on disabled elements as well.
        // This is useful for allowing tooltips to show on disabled buttons.
        element.addEventListener('pointerenter', handlePointerEnter);
        element.addEventListener('pointerleave', handlePointerLeave);
        return () => {
            element.removeEventListener('pointerenter', handlePointerEnter);
            element.removeEventListener('pointerleave', handlePointerLeave);
        };
    }, [hoverDelay, unhoverDelay, element]);
    return [setElement, hovered];
}

exports.useHover = useHover;
//# sourceMappingURL=useHover.js.map
